import React, { useEffect, useState } from "react";
import ProfileModal from "../../Modal/ProfileModal";
import { FaSync } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { makeAjax, respStatus, showMessage, url, isWebView } from "../../../helpers/global_helper";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice } from "../../NumberFormat";
import Bal_Icon from "../../../assets/images/mo_icon/Poker_Coin.png";
import { getUserProfile, getUserBalance, setCommonConfig } from "../../../redux/actions";
import defaultImg from '../../../assets/images/ProfilePic/defult.svg'
import Deer from "../../../assets/images/FestiveTheme/deer.svg";
import CoachMarkPopup from "../../Modal/CoachMarkPopup";
import plusIcon from "../../../assets/images/mo_icon/plus.svg";
import CoinReward from "./HeaderRightMenu/CoinReward";

// function DepositButton(props) {
//   return (<div>
//     <a href={props.depositUrl} target="_blank" rel="noopener noreferrer">
//       <img id="deposit_icon" src={plusIcon} alt="" />
//     </a>
//   </div>);
// }

const HeaderLeftMenu = (props) => {
  const { setLoginHeader } = props
  const user_profile = useSelector(state => state.UserProfile);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const device = useSelector(state => state.CommonConfig.device_type);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState();
  const [banner, setBanner] = useState();
  const clientLogo = banner || localStorage.getItem('logo');
  const [newAvtar, setNewAvtar] = useState(defaultImg)
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const depositUrl = sessionStorage.getItem("depositUrl");
  const [showIframe, setShowIframe] = useState(false);

  function DepositButton(props) {
    const { onClick } = props;
    return (
      <>
        <div onClick={onClick} style={{ cursor: "pointer" }}>
          <img id="deposit_icon" src={plusIcon} alt="Deposit" />
        </div>
      </>
    );
  }

  const isValidImageUrl = (url) => {
    const pattern = /avatar\/[A-Za-z0-9]+\/.*\.jpg/;
    return pattern.test(url);
  };

  useEffect(() => {
    setBanner(user_profile.loaderJS);
    if (clientLogo && user_balance.coin && user_profile.nickname) {
      setLoginHeader(true)
    }
  }, [user_profile, user_balance]);
  useEffect(() => {
    if (isValidImageUrl(user_profile.myAvatarLink)) {
      setNewAvtar(user_profile.myAvatarLink);
    } else {
      setNewAvtar(defaultImg);
    }
  }, [user_profile.myAvatarLink]);

  useEffect(() => {
    dispatch(getUserProfile());
    function checkScreenSize() {
      if (window.innerWidth <= 991) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const [isRefreshing, setISRefreshing] = useState(false);
  const [isProfilePopupOpen, setisProfilePopupOpen] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [coinRewardPopup, setCoinRewardPopup] = useState(false);
  const [totalJackpotCoins, setTotalJackpotCoins] = useState(null);

  // api for Total Jackpot Coins
  const fetchTotalJackpotCoins = () => {
    makeAjax(url.PLAYER_API.getTotalCoinReward, {}, url.PLAYER_MS_EXT).then(
      (response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code !== "validation_error") {
            showMessage(response);
            return;
          }
          showMessage(response);
          return;
        }
        setTotalJackpotCoins(response.data);
        dispatch(setCommonConfig({ key: "jackpotCoin", value: response.data }));
        setIsLoading(false);
      }
    );
  };

  const handleCoinsClick = () => {
    if (isMobile || device === "Mobile") {
      navigate("/coinReward");
    } else {
      setCoinRewardPopup(true);
    }
  };

  const handleProfileClick = () => {
    if (isMobile && device === "Mobile") {
      navigate("/profile");
    } else {
      setisProfilePopupOpen(true);
    }
  };
  const handleCloseProfilePopup = () => {
    setisProfilePopupOpen(false);
  };

  useEffect(() => {
    dispatch(getUserBalance());
    fetchTotalJackpotCoins();
    const intervalId = setInterval(() => {
      dispatch(getUserBalance());
      fetchTotalJackpotCoins();
      setLastRefreshed(new Date());
    }, 120000);
    return () => clearInterval(intervalId);
  }, []);

  const handleRefreshBalance = async () => {
    localStorage.setItem("refBtnVal", 1);
    setISRefreshing(true);
    const currentTime = new Date().getTime();
    const newClickTime = (currentTime - lastClickTime) / 1000;
    if (newClickTime < 8) {
      const remainingTime = Math.ceil(8 - newClickTime);
      setISRefreshing(false);
      let msgName = props.t('try_again_after_8_second');
      const myArray = msgName.split("8");
      showMessage(myArray[0] + remainingTime + myArray[1], "error", "Message");
    } else {
      dispatch(getUserBalance());
      setLastClickTime(currentTime);
      localStorage.setItem("refBtnVal", 0);
    }
  };

  const [isMobileLand, setIsMobileLand] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileLand(window.innerWidth <= 1024); // Adjust breakpoint as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div
        className="header_left_menu"
        style={{
          isolation:
            currentStep === (isMobileLand ? 4 : 5) ? "auto" : "isolate",
        }}
      >
        {clientLogo ? (
          <div className="client_img">
            {/* <svg>
                <image className="client_logo" xlinkHref={banner}></image>
              </svg> */}
            <img src={clientLogo} className="client_logo" alt="Client Logo" />
          </div>
        ) : (
          <></>
        )}
        {/* <div className="user_img" onClick={handleProfileClick}>
          <img src={newAvtar} alt="" />
        </div> */}
        <div className="balance">
          <div className="profile_balance">
            {/* {props.t(isMobile === false ? "User Name :" : "")}   */}
            <p> {user_profile.nickname}</p>
            <span>
              {" "}
              {/* {props.t(isMobile === false ? "Balance :" : "")}  */}
              <img className="balance_coin" src={Bal_Icon} alt=""></img>{" "}
              {user_profile.curr} {formatPrice(user_balance.coin)}
              <div
                className={`refrash_icon custom-tooltip-wrapper ${currentStep === (isMobileLand ? 4 : 5) ? "highlighted" : ""
                  }`}
                onClick={handleRefreshBalance}
              >
                <FaSync className={isRefreshing ? "refreshing" : ""} />
                {currentStep == (isMobileLand ? 4 : 5) && <CoachMarkPopup />}
              
                
              </div>
              {currentStep === (isMobileLand ? 4 : 5) && (
                <div className="custom-overlay-balance"></div>
              )}
            </span>
          </div>
       
          <div className="profile_total_coin">
            {/* <p>Total Coin : 500.00</p> */}
          </div>
          {!isLoading &&
            totalJackpotCoins !== 0 &&
            totalJackpotCoins !== "0.00" && (
              <div className="profile_total_coin" onClick={handleCoinsClick}>
                <p>
                  Total Coins:{" "}
                  <span className="total_coin_txt">
                    {formatPrice(totalJackpotCoins)}
                  </span>
                </p>
              </div>
            )}

          {currentStep === 4 && <div className="custom-overlay"></div>}
          {currentStep === 5 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}
        </div>
        {/* <div className="festiveTheme-img1-placeholder"><img src={Deer} alt="" /></div>

        {currentStep === (isMobile ? 4 : 5) && <div className="custom-overlay" style={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }}></div>} */}

        {/* {depositUrl && (
          <DepositButton depositUrl={depositUrl}></DepositButton>
        )} */}

        {depositUrl && !isWebView && (
          <div
            className={`deposit-button-wrapper custom-tooltip-wrapper ${currentStep === (isMobile ? 12 : 13) ? "highlighted" : ""
              }`}
          >
            {/* <DepositButton depositUrl={depositUrl} onClick={() => setShowIframe(true)} /> */}
            <DepositButton
              depositUrl={depositUrl}
              //  onClick={() => window.open(depositUrl, '_blank')}

              onClick={() => {
                // Hardcoded desktop window size
                const desktopWidth = 1400;
                const desktopHeight = 650;

                // Detect mobile device
                const isMobile = /Mobi|Android/i.test(navigator.userAgent);

                if (isMobile) {
                  // For mobile — open full screen
                  const fullWidth = window.screen.availWidth;
                  const fullHeight = window.screen.availHeight;

                  window.open(
                    depositUrl,
                    "_blank",
                    `width=${fullWidth},height=${fullHeight},left=0,top=0,resizable=yes,scrollbars=yes,noopener,noreferrer`
                  );
                } else {
                  // For desktop — open centered window with hardcoded size
                  const screenWidth = window.screen.availWidth;
                  const screenHeight = window.screen.availHeight;

                  const left = (screenWidth - desktopWidth) / 2; // center horizontally
                  const top = (screenHeight - desktopHeight) / 2; // position around 1/3 from top

                  window.open(
                    depositUrl,
                    "_blank",
                    `width=${desktopWidth},height=${desktopHeight},left=${left},top=${top},
      resizable=yes,scrollbars=yes,noopener,noreferrer`
                  );
                }
              }}
            />

            {currentStep == (isMobileLand ? 12 : 13) && <CoachMarkPopup />}
          </div>
        )}
        {currentStep === (isMobileLand ? 12 : 13) && <div className="custom-overlay-balance"></div>}
        {/* {alert(currentStep)} */}
      </div>

      {isProfilePopupOpen && (
        <ProfileModal
          onClose={() => {
            handleCloseProfilePopup();
          }}
        />
      )}
      {showIframe && (
        <div className="iframe-modal">
          <div className="iframe-header">
            <button onClick={() => setShowIframe(false)}>Close</button>
          </div>
          <iframe
            src={depositUrl}
            // src= "https://brovegas.wl.hkb-gaming1.com/"
            title="Deposit"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        </div>
      )}
      {coinRewardPopup && (
        <CoinReward onClose={() => setCoinRewardPopup(false)} />
      )}
    </>
  );
};

export default withTranslation()(HeaderLeftMenu);
